import React, {useState} from 'react';
import { View, Text, TextInput, Switch, StyleSheet, TouchableOpacity } from 'react-native';
import { AntDesign } from '../PlatformSpecificIcons';
import { Buffer } from 'buffer';
import colors from "../../config/colors";
import { FrameType } from './frameType';
//import styles from './styles'; // Note: You'll need to ensure that styles are imported or defined in this file

const PowerCycleFrameComponent = ({ frameCore, index, updateFrameCore }) => {
    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleTriggerFollowers = (newValue) => {
      updateFrameCore({
        ...frameCore,
        triggerFollowers: newValue,
      });
    };
  
    return (
      <View>
        <TouchableOpacity onPress={() => setIsCollapsed(!isCollapsed)}>
        <View
          style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              backgroundColor: colors.primary,
              borderTopLeftRadius: 8,
              borderTopRightRadius: 8,
              padding: 10,
            }}>
          <Text style={{fontWeight: "bold", color: "white"}}>Frame {index + 1}: Power Cycle Frame</Text>
          {!isCollapsed && <AntDesign name="upcircle" size={28} color="white" />}
          {isCollapsed && <AntDesign name="setting" size={32} color="white" />}
        </View>
        </TouchableOpacity>

        {!isCollapsed && <><View style={{padding: 10}}>  
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text>Trigger Followers:</Text>
          <Switch
            value={frameCore.triggerFollowers}
            onValueChange={toggleTriggerFollowers}
          />
        </View>
  
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text>Power Cycle Time:{'\n'}(Seconds)</Text>
          <TextInput
            style={styles.input}
            placeholder="Power Cycle Time"
            value={isNaN(frameCore.timeout) ? '' : frameCore.timeout.toString()}
            onChangeText={(text) =>
              updateFrameCore({ ...frameCore, timeout: parseInt(text) })
            }
          />
        </View>
  
        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text>Max Continous{'\n'}Events:</Text>
          <TextInput
            style={styles.input}
            placeholder="Max Continuous Events"
            value={isNaN(frameCore.maxContinuous) ? '' : frameCore.maxContinuous.toString()}
            onChangeText={(text) =>
              updateFrameCore({ ...frameCore, maxContinuous: parseInt(text) })
            }
          />
        </View>

        <View style={{ flexDirection: 'row', justifyContent: 'space-between' }}>
          <Text>Sustained Outage{'\n'}Retry(Hours):</Text>
          <TextInput
            style={styles.input}
            placeholder="Sustained Outage Retry"
            value={isNaN(frameCore.sustRetry) ? '' : frameCore.sustRetry.toString()}
            onChangeText={(text) =>
              updateFrameCore({ ...frameCore, sustRetry: parseInt(text) })
            }
          />
        </View></View></>}
      </View>
    );
  };
  
  PowerCycleFrameComponent.newFrameCore = () => ({
    frameType: FrameType.POWER_CYCLE_FRAME,
    version: 1,
    triggerFollowers: true,
    timeout: 30,
    maxContinuous: 3,
    sustRetry: 4,
  });
  
  PowerCycleFrameComponent.toBytes = (frameCore) => {
    const bytes = [];
  
    // Convert integers to 4-byte arrays

    const intToBytes = (num) => [
        num & 0xff,
        (num >> 8) & 0xff,
        (num >> 16) & 0xff,
        (num >> 24) & 0xff,
      ];
      
      const uint16ToBytes = (num) => [
        num & 0xff,
        (num >> 8) & 0xff,
      ];
  
    // Convert smaller integers to 1-byte or 2-byte arrays
    const uint8ToBytes = (num) => [num & 0xff];
  
    // Convert strings to byte arrays
    const stringToBytes = (str) => Buffer.from(str, 'utf8');
  
    // Add fields to bytes
    bytes.push(FrameType.POWER_CYCLE_FRAME); 
    bytes.push(frameCore.version); // Assuming version is uint8_t
    bytes.push(...intToBytes(frameCore.timeout*1000));
    bytes.push(frameCore.triggerFollowers ? 1 : 0);
    bytes.push(...uint8ToBytes(frameCore.maxContinuous));
    bytes.push(...uint8ToBytes(frameCore.sustRetry));
    bytes.push(0, 0, 0, 0, 0); // Spare bytes

    // Now that the byte array is complete, calculate its size
    const size = bytes.length;

    // Convert the size to a uint16 byte array
    const sizeBytes = uint16ToBytes(size);

    // Insert the size at the second position in the bytes array
    bytes.splice(1, 0, ...sizeBytes);
  
    return bytes;
  };
  
  PowerCycleFrameComponent.fromBytes = (bytes, offset) => {
    // Convert byte arrays to integers

    const bytesToInt = (arr) =>
      arr[3] << 24 | arr[2] << 16 | arr[1] << 8 | arr[0];
    
    const bytesToUint16 = (arr) =>
      arr[1] << 8 | arr[0];
  
    // Convert smaller byte arrays to integers
    const bytesToUint8 = (arr) => arr[0];
  
    // Convert byte arrays to strings
    const bytesToString = (arr) => Buffer.from(arr).toString('utf8');
  
    let index = offset;
  
    // Read fields from bytes
    const frameSize = bytesToUint16(bytes.slice(index, index + 2));
    index += 2;
    const version = bytes[index++]; // Assuming version is uint8_t
    const timeout = bytesToInt(bytes.slice(index, index + 4))/1000;
    index += 4;
    const triggerFollowers = bytesToUint8(bytes.slice(index, index + 1)) == 1;
    index++;
    const maxContinuous = bytesToUint8(bytes.slice(index, index + 1));
    index++;
    const sustRetry = bytesToUint8(bytes.slice(index, index + 1));
    index++;
    index += 5; // Spare bytes
  
    const frameCore = {
      frameType: FrameType.POWER_CYCLE_FRAME,
      version,
      sustRetry,
      maxContinuous,
      triggerFollowers,
      timeout,
    };
  
    const bytesRead = index - offset;
  
    return { frameCore, bytesRead };
  };

  const styles = StyleSheet.create({
    TextStyle: {
            color: colors.primary,
            alignSelf: "center",
        },
    picker: {
            height: 50,
            width: '75%',
            alignSelf: 'center',  // Center the picker
            },
            frameCore: {
            borderWidth: 1,
            borderRadius: 10,
            borderColor: colors.primary,
            margin: 10,
            padding: 10,
            },
            input: {
            borderWidth: 1,
            borderColor: colors.primary,
            borderRadius: 4,
            padding: 5,
            marginBottom: 10,
            width: '50%', // use the full width
            },
            inputWide: {
            borderWidth: 1,
            borderColor: colors.primary,
            borderRadius: 4,
            padding: 5,
            marginBottom: 10,
            width: '100%', // use the full width
            },
    });

  export default PowerCycleFrameComponent;